/*
* BlackSheep 2024 Theme
*/


(() => {
  const STEP_SELECTOR = ".bundle-content-container .collection-section";
  const NEXT_BTN_SELECTOR = ".bundle-step-buttons .bundle-step-button.next-step";

  // Prevent double-advancing the same step
  let lastAdvancedConditionId = null;

  const getVisibleStepEl = () => {
    // App seems to toggle inline style display: block/none
    return document.querySelector(`${STEP_SELECTOR}[style*="display: block"]`) ||
           [...document.querySelectorAll(STEP_SELECTOR)].find(el => getComputedStyle(el).display !== "none");
  };

  const getRequiredCountFromTitle = (stepEl) => {
    const title = stepEl.querySelector(".section-title")?.textContent?.trim() || "";
    // e.g. "Select 1 product from Jersey"
    const m = title.match(/select\s+(\d+)\s+product/i);
    return m ? parseInt(m[1], 10) : 1; // sensible default
  };

  const getSelectedCountInStep = (stepEl) => {
    const cards = stepEl.querySelectorAll(".product-card");
    let selected = 0;

    cards.forEach(card => {
      const qty = card.querySelector(".quantity-controls");
      const add = card.querySelector(".add-to-bundle");

      // Quantity controls visible => selected
      const qtyVisible = qty && getComputedStyle(qty).display !== "none";

      // Some implementations may hide add-to-bundle instead
      const addHidden = add && getComputedStyle(add).display === "none";

      if (qtyVisible || addHidden) selected++;
    });

    return selected;
  };

  const tryAdvance = () => {
    const stepEl = getVisibleStepEl();
    if (!stepEl) return;

    const conditionId = stepEl.getAttribute("data-condition-id") || "";
    if (conditionId && conditionId === lastAdvancedConditionId) return;

    const required = getRequiredCountFromTitle(stepEl);
    const selected = getSelectedCountInStep(stepEl);

    if (selected >= required) {
      const nextBtn = document.querySelector(NEXT_BTN_SELECTOR);
      if (nextBtn && !nextBtn.disabled) {
        lastAdvancedConditionId = conditionId || "__no_id__";
        nextBtn.click();
      }
    }
  };

  // 1) Click-based trigger: after Add to Bundle
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".product-card-cta .add-button");
    if (!btn) return;

    // let the app update UI first
    window.setTimeout(tryAdvance, 80);
  });

  // 2) Mutation trigger: if UI changes without a direct click
  const root = document.querySelector(".bundle-content-container") || document.body;
  const obs = new MutationObserver(() => {
    window.clearTimeout(tryAdvance._t);
    tryAdvance._t = window.setTimeout(tryAdvance, 80);
  });
  obs.observe(root, { subtree: true, childList: true, attributes: true });

  // Run once on load (in case the step is already satisfied)
  window.setTimeout(tryAdvance, 200);
})();





document.addEventListener('DOMContentLoaded', () => {
  const sizeFieldsets = document.querySelectorAll('.radio__fieldset');

  sizeFieldsets.forEach((fieldset) => {
    const optionName = fieldset.querySelector('.radio__legend__option-name');
    if (!optionName) return;

    if (optionName.textContent.trim().toLowerCase() !== 'size') return;

    const sizeInputs = fieldset.querySelectorAll('input[type="radio"][data-single-option-selector]');
    if (!sizeInputs.length) return;

    const selectedValue = fieldset.querySelector('[data-option-value]');
    const productForm = fieldset.closest('product-form') || document;
    const addButton =
      productForm.querySelector('[name="add"]') ||
      productForm.querySelector('button[type="submit"]');

    const addButtonText =
      addButton?.querySelector('[data-add-to-cart-text]') ||
      addButton?.querySelector('span') ||
      addButton;

    // Clear preselected size
    sizeInputs.forEach((input) => {
      input.checked = false;
      input.removeAttribute('checked');
    });

    // Reset the visible selected size text
    if (selectedValue) {
      selectedValue.textContent = 'Choose a size';
    }

    // Disable button until a size is chosen
    if (addButton) {
      addButton.disabled = true;
    }

    if (addButtonText) {
      addButtonText.textContent = 'Choose a size';
    }

    // When customer chooses a size
    sizeInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (selectedValue) {
          selectedValue.textContent = input.value;
        }

        if (addButton) {
          addButton.disabled = false;
        }

        if (addButtonText) {
          addButtonText.textContent = 'Add to cart';
        }
      });
    });
  });
});


